import { useEffect, useRef } from "react";
import { LYRICS } from "./lyricsData";

export const activeLine = (t) => {
  let idx = -1;
  LYRICS.forEach(([s], i) => { if (t >= s) idx = i; });
  return idx;
};

export const Lyrics = ({ current, onSeek }) => {
  const boxRef = useRef(null);
  const lineRefs = useRef([]);
  useEffect(() => {
    const box = boxRef.current;
    const el = lineRefs.current[current];
    if (!box || !el) return;
    box.scrollTo({ top: el.offsetTop - box.clientHeight / 2 + el.clientHeight / 2, behavior: "smooth" });
  }, [current]);

  return (
    <div className="min-w-0">
      <div className="flex items-baseline justify-between gap-4">
        <p className="mm-lab text-mm-golddark">Les paroles</p>
        <p className="text-xs opacity-70">Cliquez sur une ligne pour l'écouter</p>
      </div>
      <div ref={boxRef} className="relative mt-4 h-[460px] overflow-y-auto border-l-4 border-mm-red pl-6 pr-2 py-[180px]" data-testid="chanson-lyrics">
        {LYRICS.map(([s, text, chorus], i) => (
          <button key={`${s}-${text}`} type="button" ref={(el) => { lineRefs.current[i] = el; }} onClick={() => onSeek(s)}
            data-testid={`lyric-line-${i}`} data-active={i === current}
            className={`block w-full text-left disp leading-tight py-1.5 transition-[color,opacity,transform] duration-300 origin-left
              ${chorus ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"}
              ${i === current ? "text-mm-red opacity-100 scale-[1.03]" : current === -1 ? "opacity-80" : "opacity-35 hover:opacity-80"}`}>
            {text}
          </button>
        ))}
      </div>
      <p className="text-xs mt-3 opacity-70">Paroles retranscrites à l'écoute.</p>
    </div>
  );
};
